module.exports = __webpack_public_path__ + "static/media/display-4@768.1a81ae0f.png";